module.exports = __webpack_public_path__ + "assets/57b1c187e04d2467d594662fff322b94.mp3";